import { Popover, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/solid'
import { Fragment } from 'react'

export default function Info({riskPerTrade, stopLossPercentage, leverage}) {
  return (
    <div className="max-w-sm px-4 fixed">
      <Popover className="relative">
        {({ open }) => (
          <>
            <Popover.Button
              className={`
                ${open ? '' : 'text-opacity-90'}
                text-white group bg-orange-700 px-3 py-2 rounded-md inline-flex items-center text-base font-medium hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
            >
              <span>¿Cómo se calcula?</span>
              <ChevronDownIcon
                className={`${open ? '' : 'text-opacity-70'}
                  ml-2 h-5 w-5 text-orange-300 group-hover:text-opacity-80 transition ease-in-out duration-150`}
                aria-hidden="true"
              />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-10 w-screen max-w-sm px-4 mt-3 transform -translate-x-1/2 left-1/2 sm:px-0 lg:max-w-3xl">
                <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                  <div className="p-4 bg-gray-50">
                    <span className="text-sm font-medium text-gray-900">Para calcular el Apalancamiento <b>(Leverage)</b>, se utiiza la siguiente f&oacute;rmula:</span>
                      <span className="flex items-center mt-4">
                        <span className="text-sm font-medium text-gray-900">F&oacute;rmula:</span>
                      </span>
                      <span className="block text-sm text-gray-500">% de riesgo de la cuenta / % stop loss</span>

                      <span className="flex items-center mt-4">
                        <span className="text-sm font-medium text-gray-900">Desglose:</span>
                      </span>
                      { 
                        riskPerTrade === 0 || stopLossPercentage === 0 || leverage === 0 ?
                        <div className="text-orange-600">Debes llenar los datos en la calculadora para visualizar el desglose...</div> :
                        <div>
                          <span className="block text-sm font-medium text-gray-500">Si decimos que estamos arriesgando el {riskPerTrade}% de nuestra cuenta y tenemos un Stop Loss de {Number(stopLossPercentage).toFixed(2)}% </span><br />
                          <span className="block text-sm text-gray-500 font-medium">El apalancamiento equivale a: <b>({riskPerTrade} / {Number(stopLossPercentage).toFixed(2)}) = {riskPerTrade / Number(stopLossPercentage).toFixed(2)}x</b> </span><br />
                          <span className="font-medium text-sm text-gray-500 mt-4">Pero..., como Binance y las otras plataformas no aceptan apalancamiento con decimales, redondeamos... Es decir tendremos un apalancamiento de: <b>{leverage}x</b></span><br /><br />
                          <span className="font-medium text-sm text-gray-500 mt-4"><b>[OJO]</b> Como se hace un redondeo, lo que arriesguemos puede cambiar, por lo que recomendamos que te fijes en el apartado donde dice <b>Posible Perdida</b> para que tengas el estimado exacto de lo que puedes perder.</span>
                        </div>
                      }
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  )
}
